/* TODO(ASIMO-2105): cherrera2@ to remove once experiment is over regardless of outcome */
import { useState } from 'react';

import { getItem, setItem } from '../storage';

/**
 * A React hook that provides stateful localStorage functionality with automatic synchronization
 * between component state and browser storage. The hook initializes with a value from localStorage
 * if available, otherwise uses the provided initial value.
 *
 * @param key - The localStorage key to store/retrieve the value
 * @param initialValue - The default value to use if no stored value exists
 * @returns A tuple containing [currentValue, setValue] where setValue merges partial updates with existing state
 */
export function useBrowserStorage<T>(key: string, initialValue: T): [T, (val: T) => void] {
	const [storedValue, setStoredValue] = useState<T>(() => {
		try {
			const item = getItem(key);
			return item ?? initialValue;
		} catch (error) {
			return initialValue;
		}
	});

	const setValue = (value: Partial<T>) => {
		const newValue = { ...storedValue, ...value };
		try {
			setStoredValue(newValue);
			setItem(key, newValue);
		} catch (error) {
			return newValue;
		}
	};

	return [storedValue, setValue];
}

export default useBrowserStorage;
